import { gql } from '@apollo/client'

export const GET_ROLES = gql`
  query {
    userRoles {
      id
      name
      scope
      description
      workflow {
        id
        name
      }
    }
  }
`

export const CREATE_ROLE = gql`
  mutation CreateRole($input: RoleInput!) {
    createRole(input: $input) {
      id
      name
      scope
      description
      workflow {
        id
      }
    }
  }
`

export const UPDATE_ROLE = gql`
  mutation UpdateRole($id: ID!, $input: RoleInput!) {
    updateRole(id: $id, input: $input) {
      id
      name
      scope
      description
      workflow {
        id
      }
    }
  }
`

export const DELETE_ROLE = gql`
  mutation DeleteRole($id: ID!) {
    deleteRole(id: $id)
  }
`
